




























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {getAutocompleteFn, Autocomplete} from '@/data/sources/autocomplete';
import {throttle} from '@/utils';

const autocompleteThrottle = 500 // min time between API calls (ms)
@Component({})
export default class AutocompleteLocation extends Vue {
  @Prop() public autocompleteFn!: string
  @Prop() public autocompleteFor!: string
  @Prop() public value!: string
  public pairedInput!: HTMLElement | null
  public af?: (s: string) => Promise<Promise<Autocomplete[]>>
  public suggestions: Autocomplete[] = []
  public left: number = 0
  public top: number = 0
  public width: number = 0

  public created() {
    this.af = throttle(getAutocompleteFn(this.autocompleteFn || ''), autocompleteThrottle)
    this.pairedInput = document.getElementById(this.autocompleteFor)
  }

  private positionBox() {
    const input = document.getElementById(this.autocompleteFor)
    let rect: any
    if (input) {
      rect = input.getClientRects()[0]
      this.left = rect.x || rect.left
      this.top = rect.top + rect.height
      this.width = rect.width
    }
  }

  @Watch('value')
  async onInputChange(val: string) {
    this.positionBox()
    this.af && (this.suggestions = await this.af(val))
  }
}


